<template>
  <SmallSquare :padding='true' v-if='activeKey == 1' content="渠道订阅模板短信，针对渠道用户的短信通知。启用对应的短信模板后，在满足条件时，系统将发送短信到对应的渠道" />
  <SmallSquare :padding='true' v-else content="营销短信模板，针对一般会员短信推送内容。支持自定义创建，所有模板都是审核通过后才能使用" />
  <a-card :bordered='false'>
    <a-tabs v-model:activeKey="activeKey">
      <a-tab-pane :key="1" tab="渠道订阅模板">
        <channelSms></channelSms>
      </a-tab-pane>
      <a-tab-pane :key="2" tab="营销短信模板">
        <marketingSms></marketingSms>
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>
<script>
import { reactive, toRefs } from "vue";
import marketingSms from './components/marketingSms';
import channelSms from './components/channelSms';
export default {
  components: {
    marketingSms,channelSms
  },
  setup() {
    const state = reactive({
      activeKey:1
    });
    return {
      ...toRefs(state),
    };
  },
};
</script>